import { render, staticRenderFns } from "./EventsDivisionsScheduler.vue?vue&type=template&id=0f5a57eb&scoped=true&"
import script from "./EventsDivisionsScheduler.vue?vue&type=script&lang=ts&"
export * from "./EventsDivisionsScheduler.vue?vue&type=script&lang=ts&"
import style0 from "./EventsDivisionsScheduler.vue?vue&type=style&index=0&id=0f5a57eb&prod&scoped=true&lang=css&"
import style1 from "./EventsDivisionsScheduler.vue?vue&type=style&index=1&id=0f5a57eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a57eb",
  null
  
)

/* custom blocks */
import block0 from "./EventsDivisionsScheduler.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports